import logo2020 from "../../assets/img/nxtEvents/LogoGAB/GAB2020.png";
import logo2021 from "../../assets/img/nxtEvents/LogoGAB/GAB2021.png";
import logo2022 from "../../assets/img/nxtEvents/LogoGAB/GAB2022.png";
import logoClassic from "../../assets/img/nxtEvents/LogoGAB/TGAB.png";
import logo2024 from "../../assets/img/nxtEvents/LogoGAB/GAB2024.png";
import logo2025 from "../../assets/img/nxtEvents/LogoGAB/TGAB2025.png";
import logo2026 from "../../assets/img/nxtEvents/LogoGAB/TGAB2026.png";

export const nxtGreatAmericanBashDetail = {
  "nxt-great-american-bash": {
    id: "nxt-great-american-bash",
    title: "NXT The Great American Bash",
    subtitle: "Explore the event editions in a dedicated event view.",
    tabs: [
      {
        id: "editions",
        label: "Editions",
        variant: "nxt-great-american-bash",
        items: [
          {
            id: "nxt-great-american-bash-2020",
            title: "The Great American Bash",
            description: "NXT special episode 2020",
            imgUrl: logo2020,
          },
          {
            id: "nxt-great-american-bash-2021",
            title: "The Great American Bash",
            description: "NXT special episode 2021",
            imgUrl: logo2021,
          },
          {
            id: "nxt-great-american-bash-2022",
            title: "The Great American Bash",
            description: "NXT special episode 2022",
            imgUrl: logo2022,
          },
          {
            id: "nxt-great-american-bash-2023",
            title: "The Great American Bash",
            description: "2023",
            imgUrl: logoClassic,
          },
          {
            id: "nxt-great-american-bash-2024",
            title: "The Great American Bash",
            description: "NXT special episode 2024",
            imgUrl: logo2024,
          },
          {
            id: "nxt-great-american-bash-2025",
            title: "The Great American Bash",
            description: "Atlanta 2025",
            imgUrl: logo2025,
          },
          {
            id: "nxt-great-american-bash-2026",
            title: "The Great American Bash",
            description: "Orlando 2026",
            imgUrl: logo2026,
          },
        ],
      },
    ],
  },
};
